import { ConnectError } from "@connectrpc/connect";
import { captureException, captureMessage } from "@sentry/react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { extractConnectErrorMessage } from "../../../libs/connect";
import { t } from "../../../libs/i18n";
import { getCityAddressWithCache } from "../../../libs/sdk";
import { getIsInTargetCity } from "../../../libs/tenant";

export const Route = createFileRoute("/_authed/i/$invitationCode")({
  loader: async ({
    context: { client, tenant },
    params: { invitationCode },
  }) => {
    if (client === undefined) {
      // 権限未取得時のアクセスは client が undefined になるケースがある
      return redirect({
        to: "/",
      });
    }

    // 紹介される側（現在のユーザー）の住所が市内在住かチェック
    const cityAddress = await getCityAddressWithCache();
    if (!cityAddress || !getIsInTargetCity(tenant, cityAddress)) {
      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("お住まいの地域では招待コードを利用できません"),
            type: "error",
          },
        },
      });
    }

    if (!tenant.feature.invitation) {
      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("招待コードを利用できません"),
            type: "error",
          },
        },
      });
    }

    try {
      await client.createMyInviter({
        invitationCode,
      });

      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("招待コードを適用しました"),
            type: "success",
          },
        },
      });
    } catch (error) {
      console.error(error);
      // CatchBoundaryに到達しないためここでエラーをキャプチャする

      let skipSentry = false;

      if (error instanceof ConnectError) {
        if (error.rawMessage === "permission_denied") {
          skipSentry = true;
        }
      }

      if (!skipSentry) {
        if (error instanceof ConnectError) {
          captureMessage(extractConnectErrorMessage(error));
        } else {
          captureException(error);
        }
      }

      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("招待コードが利用できません"),
            type: "error",
          },
        },
      });
    }
  },
});
